import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@unite-us/ui';
import OverlaySpinner from '../../../common/spinners/OverlaySpinner';
import ProfilePhoneFields from './ProfilePhoneFields';
import { cleanPhoneValues } from '../../../utils/cleanContactValues';
import { phonesInitialValues } from './utils';
import callOrLog from '../../../../constants/callOrLog';
import { noop, isEqual } from 'lodash';
import { FACESHEET } from '../../../../constants/eventConstants';
import { Form } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import { trackEvent } from '../../../../config/api';
export function EditPhoneNumbers(props) {
  var phonesFieldsRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDuplicateError = _useState2[0],
    setShowDuplicateError = _useState2[1];
  var onCancel = function onCancel() {
    setShowDuplicateError(false);
    props.closeModal();
  };
  var onSubmit = function onSubmit(values) {
    var _context;
    var phones = _mapInstanceProperty(_context = values.phones || []).call(_context, cleanPhoneValues);
    callOrLog(function () {
      return trackEvent(FACESHEET.phoneUpdated);
    });
    return props.onSave(phones).then(function () {
      setShowDuplicateError(false);
      props.closeModal();
    }).catch(function (error) {
      var duplicatePhoneErr = 'phone_numbers cannot be duplicate';
      if (error.message === duplicatePhoneErr) {
        setShowDuplicateError(true);
      }
    });
  };
  var addField = function addField() {
    phonesFieldsRef.current.push({
      acceptable_communication_types: {},
      country_code: "1",
      extension: undefined,
      is_primary: false,
      phone_number: undefined,
      phone_type: undefined
    });
    window.dispatchEvent(new Event('resize'));
  };
  var handlePhoneRemove = function handlePhoneRemove(fields, index) {
    setShowDuplicateError(false);
    fields.remove(index);
  };
  var phoneFor = props.phoneFor,
    phoneTypes = props.phoneTypes,
    styles = props.styles,
    submitting = props.submitting,
    numbers = props.numbers;
  var deletingPhone = false;
  var phones = phonesInitialValues(numbers);
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
    // validate={this.validate}
    ,
    mutators: _objectSpread({}, arrayMutators),
    initialValues: {
      phones: phones
    },
    initialValuesEqual: isEqual,
    render: function render(_ref) {
      var handleSubmit = _ref.handleSubmit,
        form = _ref.form;
      return /*#__PURE__*/React.createElement("form", {
        className: "edit-phone-numbers content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(OverlaySpinner, {
        text: "Saving...",
        show: submitting || deletingPhone
      }), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(FieldArray, {
        name: "phones"
      }, function (_ref2) {
        var fields = _ref2.fields;
        phonesFieldsRef.current = fields;
        return _mapInstanceProperty(fields).call(fields, function (fieldName, index) {
          return /*#__PURE__*/React.createElement("div", {
            id: "inline-phone-".concat(index),
            key: fieldName,
            style: index !== phones.length - 1 ? styles.inlinePhoneContainer : {}
          }, /*#__PURE__*/React.createElement(ProfilePhoneFields, {
            index: index,
            fieldName: fieldName,
            inline: true,
            onRemove: function onRemove() {
              return handlePhoneRemove(fields, index);
            },
            phoneFor: phoneFor,
            phoneTypes: phoneTypes
          }));
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 text-left edit-phone-numbers__add-phone"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        onClick: addField,
        id: "add-phone-button",
        label: "+ Add Phone Number",
        className: "border-none normal-case p-0 font-black text-sm"
        // style={{ color: theme.extend.colors['action-darker-blue'] }}
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-phone-number-cancel-btn",
        onClick: onCancel,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-phone-number-save-btn"
        // onClick={handleSubmit(onSubmit)}
        ,
        disabled: submitting,
        label: "Save",
        type: "submit",
        primary: true
      })))), showDuplicateError && /*#__PURE__*/React.createElement("p", {
        className: "mt-2 text-right text-red leading-5 text-sm font-normal"
      }, "You can\u2019t add duplicate phone numbers. Delete one before saving.")));
    }
  });
}
EditPhoneNumbers.propTypes = {
  closeModal: PropTypes.func,
  onSave: PropTypes.func,
  phoneFor: PropTypes.oneOf(['contact', 'group']),
  phoneTypes: PropTypes.array.isRequired,
  styles: PropTypes.shape({
    inlinePhoneContainer: PropTypes.object.isRequired
  })
};
EditPhoneNumbers.defaultProps = {
  closeModal: noop,
  onSave: noop,
  phoneFor: 'contact',
  styles: {
    inlinePhoneContainer: {
      borderBottom: '1px solid #EBECED',
      marginBottom: '20px',
      paddingBottom: '10px'
    }
  }
};
export default EditPhoneNumbers;
//# sourceMappingURL=index.js.map